import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { ContenedoresService } from './../../../../../../../services/API/contenedores/contenedores.service';

@Component({
    selector: 'app-new-contenedor',
    templateUrl: './new-contenedor.component.html',
    styleUrls: ['./new-contenedor.component.css'],
    standalone: false
})
export class NewContenedorComponent implements OnInit {

  showProgressBar: boolean = true;
  form: UntypedFormGroup;
  matricula: string = "";
  matricula_old: string = "";
  medidas: string = "";
  estado: string = "activo";
  tipos: any = [];
  tiposSearch: any = [];
  tipo: number = -1;
  observaciones: string = "";

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private contenedoresService: ContenedoresService, private dialogRef: MatDialogRef<NewContenedorComponent>) { }

  ngOnInit(): void {
    this.getTiposContenedores();
    this.form = this.fb.group({
      matricula: [this.matricula, [Validators.required, Validators.minLength(1), Validators.maxLength(32)]],
      matricula_old: [this.matricula_old, [Validators.maxLength(32)]],
      medidas: [this.medidas, [Validators.maxLength(64)]],
      observaciones: [this.observaciones, [Validators.maxLength(256)]],
      estado: [this.estado, [Validators.required]],
      tipo: [this.tipo, [Validators.required]],
    });
  }

  getTiposContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getTiposContenedores().subscribe(result => {
      this.showProgressBar = false;
      this.tipos = result;
      this.tiposSearch = this.tipos;
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

  filterSelect_Tipos(value: string) { 
    this.tiposSearch = this.tipos.filter(option => option['nombre'].toLowerCase().includes(value.toLowerCase()));
  }

}
